<template>
    <span
        v-if="!invisible && !!(notes.length || pinnedIds.length)"
        :class="{ 'd-invisible': invisible }"
        class="pinned-notes-button"
        @click.stop.prevent
    >
        <default-button
            color="primary"
            :size="size"
            @click.stop.prevent="viewing = !viewing"
        >
            <open-icon glyph="comment" class="mr-2" />
            {{ translate("Notes") }}
        </default-button>

        <modal-dialog
            id="pinned-notes-viewer"
            :show.sync="viewing"
        >
            <template v-slot:title>
                <slot name="title"></slot>
            </template>
            <table class="table table-striped">
                <tbody>
                    <tr v-if="loading">
                        <td class="loader-container">
                            <loader size="sm" />
                        </td>
                    </tr>
                    <tr
                        v-for="note in notes"
                        :key="note.id"
                    >
                        <td>
                            <div v-html="note.content || note.description"></div>
                            <div class="text-gray text-small mt-2">
                                {{ (note.acted_at || note.updated_at) | nibnut.date }}&nbsp;@&nbsp;{{ (note.acted_at || note.updated_at) | nibnut.date("hh:mm A") }}&nbsp;&bull;&nbsp;{{ note.computed_author_name || note.computed_actor_name }}
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </modal-dialog>
    </span>
</template>

<script>
import { mapGetters } from "vuex"
import orderBy from "lodash/orderBy"

import is_remote_data_table_source from "@/nibnut/mixins/IsRemoteDataTableSource"
import misc_utilities from "@/nibnut/mixins/MiscUtilities"

import DefaultButton from "@/nibnut/components/Buttons/DefaultButton"
import OpenIcon from "@/nibnut/components/OpenIcon"

import Loader from "@/custom/components/Loader"

export default {
    name: "PinnedNotes",
    mixins: [is_remote_data_table_source, misc_utilities],
    components: {
        DefaultButton,
        OpenIcon,
        Loader,
        ModalDialog: () => import("@/nibnut/components/ModalDialog/ModalDialog")
    },
    watch: {
        viewing: "reset"
    },
    methods: {
        pre_load () {
            this.state.topic_entity = this.topicEntity
            this.state.topic_id = this.id
        }
    },
    computed: {
        ...mapGetters(["entity_records"]),
        can_refresh () {
            return !!this.profile_id && !!this.viewing
        },
        fields () {
            return ["fieldset::tooltip"]
        },
        topic_type () {
            return `App\\${this.topicEntity}`
        },
        notes () {
            return orderBy(
                this.entity_records("action_log", this.pinnedIds),
                "created_at",
                "desc"
            )
        }
    },
    props: {
        topicEntity: {
            type: String,
            required: true
        },
        id: {
            type: Number,
            required: true
        },
        pinnedIds: {
            type: Array,
            default () {
                return []
            }
        },
        size: {
            type: String,
            validator: prop => !prop || prop.match(/^(xs|sm|md|lg)$/i),
            default: "md"
        },
        invisible: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            entity: "action_log",
            default_state: {
                per_page: 0,
                page: 1,
                sort_by: "created_at",
                sort_dir: "desc",
                filter_on: null,
                filter: null,
                archived: false,
                search: "",
                total: 0,
                found: 0,
                topic_entity: "",
                topic_id: 0
            },
            viewing: false
        }
    }
}
</script>

<style lang="scss">
@import "@/assets/sass/variables";

.pinned-notes-button {
    & > .btn.btn-sm {
        height: auto;
        padding-top: 0;
        padding-bottom: 0;
        font-size: inherit;
        line-height: normal;
    }

    tbody {
        tr {
            td.loader-container {
                padding: $control-padding-y $control-padding-x;
                text-align: center;

                & > .loader {
                    margin: 0 auto;
                }
            }
        }
    }
}
</style>
